<div class="container container-settings container-student-settings">

  <div class="card mt-4">

    <div class="card-body">

      <h3 class="card-title">{{'Personal settings' | translate}}</h3>

      <div class="row">

        <div class="col-12 col-md-6">

          <h4>{{'Photo' | translate}}</h4>

          <div class="profile-image-wrapper">
            <div class="profile-image-holder circle">
              <img [src]="entity.avatarUri ? entity.avatarUri : avatarPlaceholder">
            </div>
          </div>

        </div>

        <div class="col-12 col-md-6">
          <h4>{{'General' | translate}}</h4>

          <div class="form-group">
            <label>{{'Language for website' | translate}}</label>
            <select class="form-control" [(ngModel)]="currentAccount.preferredLanguage">
              <option *ngFor="let language of supportedLanguages" [value]="language.code">
                {{language.name | translate}}
              </option>
            </select>
          </div>

        </div>

      </div>

      <div class="btn-toolbar justify-content-end">
        <button class="btn btn-primary" (click)="SaveAccount()">
          {{'Save' | translate}}
        </button>
      </div>

      <h4>{{'Contact information' | translate}}</h4>

      <div class="row">

        <div class="col-12 col-md-6">

          <div class="form-group">
            <label>{{'Phone' | translate}}</label>
            <input type="tel" class="form-control" name="tel" autocomplete="tel" [(ngModel)]="entity.phoneNumber" />
          </div>

          <div class="form-group">
            <label>{{'Email' | translate}}</label>
            <input type="email" class="form-control" readonly [(ngModel)]="currentAccount.emailAddress" />

            <button class="btn btn-primary mt-3" type="button" (click)="changeAccountEmailAddress()">
              {{'Change email address' | translate}}
            </button>
          </div>

        </div>

        <div class="col-12 col-md-6">

          <div class="row">

            <div class="col-12 col-sm-6">
              <div class="form-group">
                <label>{{'Address' | translate}}</label>
                <input type="text" class="form-control" name="address-line1" autocomplete="address-line1" [(ngModel)]="entity.homeAddress.street" />
              </div>
            </div>

            <div class="col-12 col-sm-3">
              <div class="form-group">
                <label>{{'No.' | translate}}</label>
                <input type="text" class="form-control" name="address-line2" autocomplete="address-line2" [(ngModel)]="entity.homeAddress.number" />
              </div>
            </div>

            <div class="col-12 col-sm-3">
              <div class="form-group">
                <label>{{'Addition' | translate}}</label>
                <input type="text" class="form-control" autocomplete="off" [(ngModel)]="entity.homeAddress.numberSuffix" />
              </div>
            </div>

          </div>

          <div class="form-group">
            <label>{{'City' | translate}}</label>
            <input type="text" class="form-control" name="city" autocomplete="address-level2" [(ngModel)]="entity.homeAddress.city" />
          </div>

          <div class="form-group">
            <label>{{'Zipcode' | translate}}</label>
            <input type="text" class="form-control" name="postal-code" autocomplete="postal-code" [(ngModel)]="entity.homeAddress.postalCode" />
          </div>

          <div class="form-group">
            <label>{{'Country' | translate}}</label>
            <select class="form-control" name="country" autocomplete="country" [(ngModel)]="entity.homeAddress.country">
              <option *ngFor="let country of locale.availableCountries()" [value]="country.code">
                {{country.name | translate}}
              </option>
            </select>
          </div>

        </div>

      </div>

      <div class="btn-toolbar justify-content-end">
        <button class="btn btn-primary" (click)="Save()">
          {{'Save' | translate}}
        </button>
      </div>

      <div class="change-password mt-4">

        <h4>{{'Change password' | translate}}</h4>

        <a [href]="passwordResetUrl" class="btn btn-outline-primary">
          {{'Change password' | translate}}
        </a>

      </div>

      <!-- email settings -->
      <div class="email-settings mt-4">

        <h4>{{'Receive emails' | translate}}</h4>

        <div class="form-group d-none">
          <div class="custom-control custom-checkbox">
            <input class="custom-control-input" type="checkbox" />
            <label class="custom-control-label">{{'I want to get an email when I receive a new message' | translate}}</label>
          </div>
        </div>

        <div class="form-group d-none">
          <div class="custom-control custom-checkbox">
            <input class="custom-control-input" type="checkbox" />
            <label class="custom-control-label">{{'I want to get an emails with overviews of companies and vacancies' | translate}}</label>
          </div>
        </div>

        <div class="form-group">
          <div class="custom-control custom-checkbox">
            <input class="custom-control-input" id="allowEmailNotifications" type="checkbox" [(ngModel)]="entity.allowEmailNotifications" />
            <label class="custom-control-label" for="allowEmailNotifications">{{'I want to get email notifications' | translate}}</label>
          </div>
        </div>

        <div class="form-group">
          <div class="custom-control custom-checkbox">
            <input class="custom-control-input" id="isSubscribedToNewsletter" type="checkbox" [(ngModel)]="entity.isSubscribedToNewsletter" />
            <label class="custom-control-label" for="isSubscribedToNewsletter">{{'I want to receive newsletters' | translate}}</label>
          </div>
        </div>

        <h4>{{'Privacy settings' | translate}}</h4>

        <div class="form-group">
          <div class="custom-control custom-checkbox">
            <input class="custom-control-input" id="hasMediaConsent" type="checkbox" [(ngModel)]="entity.hasMediaConsent" />
            <label class="custom-control-label" for="hasMediaConsent">
              {{'I consent with the use of media that may include me.' | translate}}
              <br />
              <a target="_blank" href="/pages/privacyverklaring">{{ 'Read privacy statement' | translate}}</a>
            </label>
          </div>
        </div>

        <!-- Filter settings for international students (#17796) -->
        <h4>{{'Filter settings' | translate}}</h4>

        <div class="form-group">
          <div class="custom-control custom-checkbox">
            <input class="custom-control-input" id="showAllCompanies" type="checkbox" [(ngModel)]="currentAccount.disableTargetGroupsCompanies" />
            <label class="custom-control-label" for="showAllCompanies">{{'Show all companies' | translate}}</label>
          </div>
        </div>

        <div class="form-group">
          <div class="custom-control custom-checkbox">
            <input class="custom-control-input" id="showAllVacancies" type="checkbox" [(ngModel)]="currentAccount.disableTargetGroupsJobs" />
            <label class="custom-control-label" for="showAllVacancies">{{'Show all vacancies' | translate}}</label>
          </div>
        </div>

        <div class="form-group">
          <div class="custom-control custom-checkbox">
            <input class="custom-control-input" id="showAllMeetDays" type="checkbox" [(ngModel)]="currentAccount.disableTargetGroupsMeetDays" />
            <label class="custom-control-label" for="showAllMeetDays">{{'Show all meet days' | translate}}</label>
          </div>
        </div>

        <!-- Privacy: hide profile from specific companies (#18132) -->
        <h4>{{'Privacy' | translate}}</h4>

        <form [formGroup]="blacklistForm">
          <formly-form
            [form]="blacklistForm"
            [fields]="blacklistFields"
            [model]="entity"
          ></formly-form>
        </form>

      </div>

      <div class="btn-toolbar justify-content-end">
        <button class="btn btn-primary" (click)="Save()">
          {{'Save' | translate}}
        </button>
      </div>

      <!-- delete account -->
      <div class="delete-account">

        <h4>{{'Delete account' | translate}}</h4>

        <p>
          {{'You really want to delete your account?' | translate}} {{'Then press the button below and you data will be deleted.' | translate}}
        </p>

        <button class="btn btn-danger" data-cy="deleteaccount" (click)="deleteAccount()">
          {{'Delete my account' | translate}}
        </button>

      </div>

    </div>
  </div>
</div>
